import { memo, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Col, Form, Row } from 'react-bootstrap';
import { useClickAway } from 'react-use';
import {
  getDragDropStyle,
  itemBottomGapStyle,
  itemTitleStyle,
  isHiddenInPrint,
  itemSettingStyle,
  lineHeightStyle,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';
import SelectedItemSearch from './selectedItemSearch';
import { useSelector } from 'react-redux';
import NoteDropdown from '../noteDropdown';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const Advice = ({
  element,
  prescriptionItems,
  setShowAdvice,
  selectedAdvices,
  setSelectedAdvices,
  deletePrescriptionItem,
  isHistoryPage = false,
  isInLeftSide = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);
  const [isEdit, setIsEdit] = useState('');
  const [selectedForSub, setSelectedForSub] = useState('');
  let formatedAdvices = [];
  let key = 'untitled';
  selectedAdvices?.forEach((item) => {
    if (item?.title) {
      key = item?.title;
      formatedAdvices[key] = [item];
    } else {
      if (Array.isArray(formatedAdvices[key])) {
        formatedAdvices[key].push(item);
      } else {
        formatedAdvices[key] = [item];
      }
    }
  });

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = reorder(
      selectedAdvices,
      result.source.index,
      result.destination.index,
    );
    setSelectedAdvices(reorderedItems);
  };

  // this function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const removeAdvice = (type, itemName) => {
    const data = selectedAdvices.filter(
      (selectedItem) => selectedItem.name !== itemName,
    );
    setSelectedAdvices([...data]);
    setSelectedForSub('');
  };

  const removeSubAdvice = (item, subItemId) => {
    let subItems = item?.subAdvices;
    subItems = subItems.filter((subItem) => subItem.id !== subItemId);
    item.subAdvices = subItems;
    const advices = selectedAdvices.map((advice) => {
      if (advice.id === item.id) {
        return item;
      } else {
        return advice;
      }
    });
    setSelectedAdvices([...advices]);
  };

  const handleSelectedForSub = (itemId) => {
    if (itemId === selectedForSub) {
      setSelectedForSub('');
    } else {
      setSelectedForSub(itemId);
    }
  };

  const handleAdviceNote = (key, val) => {
    selectedAdvices[key].note = val;
    setSelectedAdvices([...selectedAdvices]);
  };

  const handleAdviceSubNote = (itemMain, parentIndex, key, val) => {
    itemMain.subAdvices[key]['note'] = val;
    selectedAdvices[parentIndex] = itemMain;
    setSelectedAdvices([...selectedAdvices]);
  };

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsEdit('');
  });

  const selectedSubAdviceList = (itemMain, parentIndex) =>
    itemMain?.subAdvices?.map((item, index) => {
      return (
        <Row
          className="selected-item-row"
          key={index}
          style={{ marginLeft: '20px', marginRight: '20px' }}
        >
          <Col>{item.name}</Col>
          <Col>
            <NoteDropdown
              value={item.note || ''}
              onChange={(val) => handleAdviceSubNote(itemMain, parentIndex, index, val)}
              placeholder="Add Note"
              suggestions={allNotes.filter(
                (n) => n.elementType === 'advice' && n.itemElement?.toLowerCase() === item.name?.toLowerCase(),
              )}
            />
          </Col>
        </Row>
      );
    });

  const editMode = (item, index) => {
    return (
      <>
        {item?.title && (
          <span className="advice-title" key={index}>
            {item?.title}:{' '}
          </span>
        )}
        <Row ref={ref} className="selected-row-right" key={index}>
          {/* <Col>{item.name}</Col> */}
          <Col className="pl-0 pr-0">
            <SelectedItemSearch
              apiUrl="advice"
              selectedItemName={item.name}
              selectedItems={selectedAdvices}
              selectedItemsAction={setSelectedAdvices}
            />
          </Col>
          <Col>
            <NoteDropdown
              value={item.note || ''}
              onChange={(val) => handleAdviceNote(index, val)}
              placeholder="Add Note"
              suggestions={allNotes.filter(
                (n) => n.elementType === 'advice' && n.itemElement?.toLowerCase() === item.name?.toLowerCase(),
              )}
            />
          </Col>
          <Col md={1} className="text-right">
            <i
              className="far fa-times-circle"
              aria-hidden="true"
              onClick={() => setIsEdit('')}
            ></i>
          </Col>
        </Row>
        {selectedSubAdviceList(item, index)}
      </>
    );
  };

  const deleteAdvice = (itemName, parentName, type) => {
    let result = selectedAdvices;
    if (type === 'advice') {
      result = selectedAdvices.filter((advice) => advice.name !== itemName);
    } else {
      const index = selectedAdvices.findIndex(
        (advice) => advice.name === parentName,
      );
      if (index !== -1) {
        console.log(selectedAdvices[index], parentName, type);
        let subAdvs = selectedAdvices[index]?.subAdvices?.filter(
          (advice) => advice.name !== itemName,
        );
        result[index].subAdvices = subAdvs;
      }
    }
    setSelectedAdvices([...result]);
  };

  const prescriptionItemCSSObject = () => itemBottomGapStyle(element, selectedAdvices.length === 0);

  return (
    <div
      className={`row item-row ${
        selectedAdvices?.length ? 'data-item-history' : ''
      }`}
      key={`advice`}
      style={prescriptionItemCSSObject()}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'advice') ? 'item-title-hide' : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['advice']?.titleStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowAdvice(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Advice</span>
        )}
      </span>
      {Object.keys(formatedAdvices)?.map((key) => {
        return (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <ol
                  className={`sub-child-list advice-ul view-ul ${
                    isInLeftSide ? 'item_left_padding' : ''
                  }`}
                  style={{
                    ...itemSettingStyle(
                      prescriptionItems?.items?.['advice']?.itemStyle || {},
                    ),
                    ...lineHeightStyle('advice', prescriptionItems),
                  }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {formatedAdvices[key]?.map((item, index) => (
                    <Draggable
                      key={item.name}
                      draggableId={item.name}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <>
                          {item?.title && (
                            <span className="advice-title">
                              {item?.title}:{' '}
                            </span>
                          )}
                          <li
                            key={index}
                            className="advice-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...getDragDropStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                              ),
                              position: 'relative',
                            }}
                          >
                            <div onClick={() => setIsEdit(index)}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span
                                  style={itemSettingStyle(
                                    prescriptionItems?.items?.['advice']
                                      ?.itemStyle || {},
                                  )}
                                >
                                  {item.name}
                                  {prescriptionItems?.items?.['advice']?.notePosition === 'same-line' && item.note
                                    ? ` - ${item.note}`
                                    : ''}
                                </span>
                                {!isHistoryPage && (
                                  <ChiefComplainDeleteBtn
                                    action={removeAdvice}
                                    itemName={'advice'}
                                    delId={item.name}
                                  />
                                )}
                              </div>
                              {item.note && prescriptionItems?.items?.['advice']?.notePosition !== 'same-line' && (
                                <div className="preline">
                                  <span
                                    className="text-left pr-5"
                                    style={itemSettingStyle(
                                      prescriptionItems?.items?.['advice']
                                        ?.subItemStyle || {},
                                    )}
                                  >
                                    {item.note}
                                  </span>
                                </div>
                              )}
                              <ul>
                                {item?.subAdvices?.map(
                                  (subAdvice, subIndex) => (
                                    <li
                                      key={subAdvice.name}
                                      className="advice-item-sub"
                                    >
                                      <div>
                                        <span
                                          className="text-left pr-5"
                                          style={itemSettingStyle(
                                            prescriptionItems?.items?.['advice']
                                              ?.itemStyle || {},
                                          )}
                                        >
                                          {subAdvice.name}
                                          {prescriptionItems?.items?.['advice']?.notePosition === 'same-line' && subAdvice.note
                                            ? ` - ${subAdvice.note}`
                                            : ''}
                                        </span>
                                        {!isHistoryPage && (
                                          <CommonDeleteBtn
                                            action={removeSubAdvice}
                                            itemName={item}
                                            delId={subAdvice.id}
                                          />
                                        )}
                                      </div>
                                      {subAdvice.note && prescriptionItems?.items?.['advice']?.notePosition !== 'same-line' && (
                                        <div className="preline">
                                          <span
                                            className="text-left pr-5"
                                            style={itemSettingStyle(
                                              prescriptionItems?.items?.[
                                                'advice'
                                              ]?.subItemStyle || {},
                                            )}
                                          >
                                            <i>- {subAdvice.note}</i>
                                          </span>
                                        </div>
                                      )}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                            {index === isEdit && editMode(item, index)}
                          </li>
                        </>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ol>
              )}
            </Droppable>
          </DragDropContext>
        );
      })}
    </div>
  );
};

export default memo(Advice);
